export enum SysAdminAuditEventType {
    UID_ACCOUNT_CREATED = 'Universal ID Account Created',
    UID_ACCOUNT_UPDATED = 'Universal ID Account Updated',
    UID_ACCOUNT_LINKED = 'Universal ID Account Linked',
    ENTERPRISE_ADMIN_ROLE_ADDED = 'Enterprise Admin Role Added',
    ENTERPRISE_ADMIN_ROLE_REMOVED = 'Enterprise Admin Role Removed',
    ENTERPRISE_GROUP_CREATED = 'Enterprise Group was Created',
    ENTERPRISE_GROUP_NAME_CHANGED = 'Enterprise Group Name Changed',
    ENTERPRISE_GROUP_STATUS_CHANGED = 'Enterprise Group status changed (active/inactive)',
    INSTANCES_UPDATED = 'Instances added and/or removed in Enterprise Group',
    ORG_ADMIN_SELECTION_CHANGED = 'Universal ID user selected/unselected as OrgAdmin',
    ENTERPRISE_ORGANIZATION_ADDED = 'Enterprise Added Instance',
    ENTERPRISE_ORGANIZATION_REMOVED = 'Enterprise Removed Instance',
    IDENTITY_BROKERING_CHANGED = 'Identity Brokering Model Changed',
    ENTERPRISE_SETTINGS_CHANGED = 'Enterprise Settings Changed',
    ORGANIZATION_RELOCATED = 'Site moved to another organization',
    BULK_ACTION_JOB_CREATED = 'Upload CSV request Created',
    BULK_ACTION_JOB_UPDATED = 'Upload CSV request Updated',
    SSO_USER_IMPERSONATE = 'Sso User Impersonated',
    AUDIT_REPORT_CREATED = 'Audit Report Created',
    AUDIT_REPORT_UPDATED = 'Audit Report Changed',
    PASSWORD_RESET = 'Password Reset',
    ORGANIZATION_ATTRIBUTE_SET = 'Organization Attribute Changed',
}
